import { experiment } from "@faire/web/common/settings/declarations/experiment";

/**
 * Batch 12 A/B test to swap featured brands with bestsellers on logged out homepage
 */
export const FE_BATCH_12_SWAP_FEATURED_BRANDS_WITH_BESTSELLERS_250814 =
  experiment({
    name: "FE_BATCH_12_SWAP_FEATURED_BRANDS_WITH_BESTSELLERS_250814",
    identifier: "SessionToken",
    client: ["RETAILER", "VISITOR_WEB"],
    notifyAfter: "2025-11-14",
    defaultValue: false,
    productArea: "LOGGED_OUT_RETAILERS",
  });
